import { type UnitOut, refKeys, unitsApi } from '@/features/references/api'
import { typedSuspenseOptions } from '@/lib/query/typed-suspense-query'

export const unitsListQuery = () =>
  typedSuspenseOptions<readonly UnitOut[]>({
    queryKey: refKeys.units(),
    queryFn: ({ signal }) => unitsApi.list(signal),
    staleTime: 30_000,
  })
